<template>
  <div class="press">
    <div class="body-container">
      <div class="common-title">{{$t('home.press')}}</div>
      <div class="press-content">
        <div class="row flex justify-center">
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="flex shrink justify-center" style="flex-wrap: nowrap">
              <a target="_blank" href="https://www.coindesk.com/baidu-owned-video-streaming-giant-iqiyi-taps-public-blockchain-for-performance-boost">
                <img src="/static/img/home/press/press-1.png" alt="">
              </a>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="flex shrink justify-center" style="flex-wrap: nowrap">
              <a target="_blank" href="https://cryptobriefing.com/?s=NKN">
                <img src="/static/img/home/press/press-2.png" alt="">
              </a>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="flex justify-center" style="flex-wrap: nowrap;flex-shrink: 0;">
              <a target="_blank" href="https://www.gsma.com/futurenetworks/wiki/nkn/">
                <img src="/static/img/home/press/press-3.png" alt="">
              </a>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="flex justify-center" style="flex-wrap: nowrap;">
              <a target="_blank" href="https://thedailychain.com/?s=NKN">
                <img src="/static/img/home/press/press-4.png" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DappModule from "@/components/developer/plugins/dAppModule";

  export default {
    components: {
      DappModule
    },
    methods: {
      langTo(path) {
        let root = "";
        if (!!this.$route.params.lang) {
          root = `/${this.$route.params.lang}`;
        }
        return `${root}${path}`;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .press {
    padding: 4rem 0;
    @media screen and (max-width: 768px) {
      padding: 0;
    }

    &-content {
      margin-top: 2rem;
      margin-left: 2rem;

      @media screen and (max-width: 992px) {
        margin-left: 10rem;
      }
      @media screen and (max-width: 900px) {
        margin-left: 8rem;
      }
      @media screen and (max-width: 800px) {
        margin-left: 6rem;
      }
      @media screen and (max-width: 768px) {
        margin: 0;
        .row {
          width: 60%;
          margin-left: auto !important;
          margin-right: auto !important;
        }
      }
      @media screen and (max-width: 550px) {
        .row {
          width: 100%;
          margin-left: auto !important;
          margin-right: auto !important;
        }
      }

      .link-module {
        margin-bottom: 3rem;

        ul {
          padding-left: 1rem;
          padding-right: 1rem;
        }

        @media screen and (max-width: 768px) {
          margin-left: 1rem;
        }

        &-title {
          @include nkn-font-set(1.2rem, currentColor);
          line-height: 1.2rem;

          @media screen and (max-width: 768px) {
            margin-top: 2rem;
          }
        }

        &-text {
          @include nkn-font-set(0.7rem, currentColor);
          line-height: 1rem;
          margin-top: 1rem;
          min-height: 2.25rem;

          // @media screen and (max-width: 768px) {
          //   display: inline-block;
          // }

          i {
            flex-shrink: 0;
            vertical-align: middle;
          }

          span {
            display: inline-block;
            padding-top: 0.25rem;
            margin-left: 0.5rem;

            @media screen and (max-width: 768px) {
            }
          }

          & > a {
            display: flex;
            align-items: center;

            &:hover {
              color: #1791f2 !important;
            }
          }
        }
      }

      img {
        height: 70px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/press.vue